import { createRouter, createWebHistory } from 'vue-router'
// import { createRouter, createWebHashHistory } from 'vue-router'

import Index from '../components/Index'
import ProductCenter from '@/views/ProductCenter/ProductCenter.vue'
import ShoppingPage from '@/views/ShoppingPage/index.vue'
import ShoppingDetailPage1 from '@/views/ShoppingDetailPage1/ShoppingDetailPage1.vue'
import ShoppingDetailPage2 from '@/views/ShoppingDetailPage2/ShoppingDetailPage2.vue'
import ShoppingDetailPage3 from '@/views/ShoppingDetailPage3/ShoppingDetailPage3.vue'
import userAgreement from '../components/userAgreement'
import privacyPolicy from '../components/privacyPolicy'


export default createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/ProductCenter',
            name: 'ProductCenter',
            component: ProductCenter
        },
        {
            path: '/userAgreement',
            name: 'userAgreement',
            component: userAgreement
        },
        {
            path: '/privacyPolicy',
            name: 'privacyPolicy',
            component: privacyPolicy
        },
        {
            path: '/ShoppingPage',
            name: 'ShoppingPage',
            component: ShoppingPage
        },
        {
            path: '/ShoppingDetailPage1',
            name: 'ShoppingDetailPage1',
            component: ShoppingDetailPage1
        },
        {
            path: '/ShoppingDetailPage2',
            name: 'ShoppingDetailPage2',
            component: ShoppingDetailPage2
        },
        {
            path: '/ShoppingDetailPage3',
            name: 'ShoppingDetailPage3',
            component: ShoppingDetailPage3
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    }
})
